import { gql } from '@apollo/client';
import { PARAMETER_FIELDS } from '@isyc-react/oc-api';
export const SIGNATORY_FIELDS = gql `
  ${PARAMETER_FIELDS}
  fragment SignatoryFields on SignatoryDto {
    id
    sex
    birthName
    firstname
    surname
    birthDate
    mail
    personalPhone {
      prefix
      number
    }
    mobilePhone {
      prefix
      number
    }
    parameters {
      ...ParameterFields
    }
    erasable
  }
`;
export const OCCUPANT_FIELDS = gql `
  ${PARAMETER_FIELDS}
  fragment OccupantFields on OccupantDto {
    id
    sex
    birthName
    firstname
    surname
    birthDate
    parameters {
      ...ParameterFields
    }
    erasable
  }
`;
